import { useState, useRef, useCallback } from 'react';

const RADIUS = 13;
const CIRC   = 2 * Math.PI * RADIUS;
const HOLD_MS = 900;

function JulaNove() {
    const [progress, setProgress] = useState(0);
    const [done,     setDone]     = useState(false);
    const rafRef   = useRef(null);
    const startRef = useRef(null);

    const cancel = useCallback(() => {
        cancelAnimationFrame(rafRef.current);
        setProgress(0);
        startRef.current = null;
    }, []);

    const tick = useCallback(() => {
        const p = Math.min(100, ((Date.now() - startRef.current) / HOLD_MS) * 100);
        setProgress(p);
        if (p < 100) {
            rafRef.current = requestAnimationFrame(tick);
        } else {
            setDone(true);
            setTimeout(() => {
                setProgress(0);
                setDone(false);
                window.open('https://www.facebook.com/julanove/', '_blank', 'noreferrer');
            }, 500);
        }
    }, []);

    const start = useCallback((e) => {
        e.preventDefault();
        if (done) return;
        startRef.current = Date.now();
        rafRef.current = requestAnimationFrame(tick);
    }, [tick, done]);

    const active     = progress > 0 && !done;
    const pct        = Math.round(progress);
    const dashOffset = CIRC * (1 - progress / 100);

    return (
        <span
            className={`jula-hold${active ? ' jula-hold--active' : ''}${done ? ' jula-hold--done' : ''}`}
            onMouseDown={start}
            onMouseUp={cancel}
            onMouseLeave={cancel}
            onTouchStart={start}
            onTouchEnd={cancel}
        >
            <svg className="jula-ring" viewBox="0 0 32 32" aria-hidden="true">
                <circle cx="16" cy="16" r={RADIUS} className="jula-ring-bg" />
                <circle
                    cx="16" cy="16" r={RADIUS}
                    className="jula-ring-fill"
                    strokeDasharray={CIRC}
                    strokeDashoffset={done ? 0 : dashOffset}
                    style={{ transition: active ? 'none' : 'stroke-dashoffset 0.2s ease' }}
                />
            </svg>
            <span className="jula-hold-text">
                {done ? '🌸' : 'julanove'}
            </span>
            {active && <span className="jula-pct">{pct}%</span>}
        </span>
    );
}

function Footer() {
    return (
        <footer className="site-footer">
            <div className="footer-cover-title flex justify-content-center align-items-center">
                <h2>YOSAKOI</h2>
            </div>

            <div className="footer-content-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="entry-title">
                                <a href="/">VIỆT NAM YOSAKOI</a>
                            </div>

                           {/*  <div className="entry-mail">
                                <a href="mailto:sayhello@yosakoi.com">SAYHELLO@YOSAKOI.COM</a>
                            </div> */}

                            <div className="copyright-info">
                                &copy; {new Date().getFullYear()} All rights reserved | This website is made with{' '}
                                <i className="fa fa-heart" aria-hidden="true"></i> by{' '}
                                <JulaNove />
                            </div>

                            <div className="footer-social">
                                <ul className="flex justify-content-center align-items-center">
                                    <li><a href="#"><i className="fab fa-pinterest"></i></a></li>
                                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i className="fab fa-dribbble"></i></a></li>
                                    <li><a href="#"><i className="fab fa-behance"></i></a></li>
                                    <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
